import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ContractTemplateComponent } from './contract-template/contract-template.component';
import { CreateContractComponent } from './create-contract/create-contract.component';
import { NegotiationComponent } from './negotiation/negotiation.component';
import { RepositoryComponent } from './repository/repository.component';
import { ExecutionComponent } from './execution/execution.component';
import { PostExecutionComponent } from './post-execution/post-execution.component';
import { ObligationComponent } from './obligation/obligation.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartModule } from 'primeng/chart';

import { ReportsComponent } from './reports/reports.component';
import { ContractFeedbackComponent } from './contract-feedback/contract-feedback.component';
import { ContractSettingsComponent } from './contract-settings/contract-settings.component';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { SharedModule } from '../../../modules/shared/shared.module';
import { ConfigComponent } from './config/config.component';
import { ContractService } from './service/contract.service';
import { TrainingComponent } from './training/training.component';
import { BotGlobalSearchComponent } from './bot-global-search/bot-global-search.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { NewUserComponent } from './new-user/new-user.component';
import { UserService } from './user-management/service/userservice';
import { PhoneNumberInputComponent } from '../../../components/phone-number-input/phone-number-input.component';
import { ContractsTableComponent } from './contracts-filter/contracts-filter.component';
import { ContractInboxComponent } from './inbox-contracts/inbox-contracts.component';

const routes: Routes = [
  {
    path: 'createTemplate',
    component: ContractTemplateComponent,
  },
  {
    path: 'createContract',
    component: CreateContractComponent,
  },
  {
    path: 'negotiation',
    component: NegotiationComponent,
  },
  {
    path: 'execution',
    component: ExecutionComponent,
  },
  {
    path: 'repository',
    component: RepositoryComponent,
  },
  {
    path: 'obligation',
    component: ObligationComponent,
  },
  {
    path: 'reports',
    component: ReportsComponent,
  },
  {
    path: 'settings',
    component: ContractSettingsComponent,
  },
  {
    path: 'userManagement',
    component: UserManagementComponent,
    children: [
      { path: ':user', component: UserDetailsComponent },
      { path: 'newUser', component: NewUserComponent },
    ],
  },
  {
    path: 'training',
    component: TrainingComponent,
  },
  {
    path: 'config',
    component: ConfigComponent,
  },
  {
    path: 'contract-filter',
    component: ContractsTableComponent,
  },
  {
    path: 'inbox',
    component: ContractInboxComponent,
  },
  {
    path: 'global-search',
    component: BotGlobalSearchComponent,
  },
  {
    path: 'feedback',
    component: ContractFeedbackComponent,
  },
  {
    path: '',
    redirectTo: 'training',
    pathMatch: 'full',
  },
];

@NgModule({
  declarations: [
    ContractTemplateComponent,
    CreateContractComponent,
    NegotiationComponent,
    RepositoryComponent,
    ExecutionComponent,
    PostExecutionComponent,
    ObligationComponent,
    ConfigComponent,
    ReportsComponent,
    ContractFeedbackComponent,
    ContractSettingsComponent,
    TrainingComponent,
    BotGlobalSearchComponent,
    UserManagementComponent,
    UserDetailsComponent,
    NewUserComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ChartModule,
    SharedModule,
    ReactiveFormsModule,
    PhoneNumberInputComponent,
    ContractsTableComponent,
    ContractInboxComponent,
    RouterModule.forChild(routes),
    NgxDaterangepickerMd.forRoot(),
  ],
  providers: [
    provideCharts(withDefaultRegisterables()),
    ContractService,
    UserService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContractsModule {}
